import React, { useState } from 'react';
import axios from 'axios'; // Import axios
import Header from './Header';
import { Link } from 'react-router-dom';

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastname: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    // e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    try {
       await axios.post("https://applicationback-sigma.vercel.app/api/contact", formData);
      setResponseMessage("Message sent successfully!");
    } catch (error) {
      setResponseMessage("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
        <Header/>
        <section className="contact-section padding">
  <div className="map-pattern" />
  <div className="container">
    <div className="row">
      <div className="col-lg-7 sm-padding">
        <div className="contact-form-wrap row-gap">
          <div className="section-heading mb-40">
            <h3 className="sub-heading is-border border-anim">
              Send Us Mail
              <span className="sh-underline">
                <img className="sh-truck" src="images/truck.svg" alt="truck" />
              </span>
            </h3>
            <h2
              className="text-anim"
              data-effect="fade-in-right"
              data-split="char"
              data-delay="0.3"
              data-duration={1}
            >
            Get a Free Freight Quote   
            </h2>
            <p
              className="text-anim"
              data-effect="fade-in-bottom"
              data-ease="power4.out"
            >
             Request a free quote or speak to our trucking experts. Safe and Reliable Transportation is ready to handle your freight needs.
            </p>
          </div>
          <div className="contact-form">
          <div  className="form-horizontal">
                    <div className="contact-form-group">
                      <div className="form-field">
                        <input
                          type="text"
                          name="firstName"
                          className="form-control"
                          placeholder="First Name"
                          required
                          value={formData.firstName}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-field">
                        <input
                          type="text"
                          name="lastname"
                          className="form-control"
                          placeholder="Last Name"
                          required
                          value={formData.lastname}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-field">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-field">
                        <input
                          type="text"
                          name="phone"
                          className="form-control"
                          placeholder="Phone Number"
                          required
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-field message">
                        <textarea
                          name="message"
                          cols={30}
                          rows={4}
                          className="form-control"
                          placeholder="Message"
                          required
                          value={formData.message}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="form-field submit-btn">
                        <button  className="default-btn" onClick={()=>{handleSubmit()}} disabled={loading}>
                          {loading ? "Sending..." : "Send Message"}
                        </button>
                      </div>
                    </div>
                    {responseMessage && <div className="alert">{responseMessage}</div>}
                  </div>
          </div>
        </div>
      </div>
      <div className="col-lg-5 sm-padding">
        <div className="section-heading mb-40">
          <h3 className="sub-heading is-border border-anim">
            Need Any Help?
            <span className="sh-underline">
              <img className="sh-truck" src="images/truck.svg" alt="truck" />
            </span>
          </h3>
          <h2
            className="text-anim"
            data-effect="fade-in-right"
            data-split="char"
            data-delay="0.3"
            data-duration={1}
          >
            Get In Touch <br />
            <span className="hl">With Us!</span>
          </h2>
          <p
            className="text-anim"
            data-effect="fade-in-bottom"
            data-ease="power4.out"
          >
            Safe and Reliable Transportation specializes in the efficient
            management and coordination of the movement of goods
          </p>
        </div>
        <ul className="contact-info-list">
     <a href='mailto:humanresource@srtranspor.com'>    <li className="wow fade-in-bottom mb-2" data-wow-delay="300ms">
            <i className="fa-light fa-envelope-open-text" />
            <h3>
              Write us email <span>humanresource@srtranspor.com</span>
            </h3>
          </li>
          </a> 
          <li className="wow fade-in-bottom" data-wow-delay="500ms">
            <i className="fa-light fa-location-dot" />
            <h3>
              Address<span> 9528 Baltimore, Ave
Laurel, MD 20723</span>
            </h3>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

  <footer className="footer-section">
     <div className="map-pattern" />
     <div className="footer-wrapper">
       <div className="container">
         <div className="row gy-lg-0 gy-4">
           <div className="col-lg-3 col-md-6">
             <div className="footer-widget">
               <Link to="/" className="footer-logo">
                 <img src="images/logo.png" alt="logo" />
               </Link>
               <p>
               Safe and Reliable Transportation specializes in efficient
                 transport warehousing and distribution of goods.
               </p>
               <ul className="social-share">
                 <li>
                   <Link to="#">
                     <i className="fa-brands fa-facebook-f" />
                   </Link>
                 </li>
                 <li>
                   <Link to="#">
                     <i className="fa-brands fa-x-twitter" />
                   </Link>
                 </li>
                 <li>
                   <Link to="#">
                     <i className="fa-brands fa-instagram" />
                   </Link>
                 </li>
                 <li>
                   <Link to="#">
                     <i className="fa-brands fa-tiktok" />
                   </Link>
                 </li>
               </ul>
             </div>
           </div>
           <div className="col-lg-3 col-md-6">
             <div className="footer-widget widget-links">
               <div className="widget-title">
                 <h3>Company</h3>
               </div>
               <ul className="footer-links">
                 <li>
                   <Link to="/aboutus">About Us</Link>
                 </li>
                 <li>
                   <Link to="/services">Our Services</Link>
                 </li>
                 <li>
                   <Link to="/testimonials">Testimonials</Link>
                 </li>
                 <li>
                   <Link to="/contact">Contact</Link>
                 </li>
               </ul>
             </div>
           </div>
           <div className="col-lg-3 col-md-6">
             <div className="footer-widget">
               <div className="widget-title">
                 <h3>Get In Touch</h3>
               </div>
               <ul className="footer-contact-info">
                 <li>
                   <p>
                     <span>Address:</span>9528 Baltimore, Ave
Laurel, MD 20723
                   </p>
                 </li>
                 <li>
                   <p>
                     <span>Mail Us:</span>humanresource@srtranspor.com
                   </p>
                 </li>
               </ul>
             </div>
           </div>
           <div className="col-lg-3 col-md-6">
             <div className="footer-widget">
               <div className="widget-title">
                 <h3>Newslatter Signup</h3>
               </div>
               <form action="#" className="subscribe-form" noValidate="true">
                 <div className="mc-fields">
                   <input
                     className="form-control"
                     type="email"
                     name="EMAIL"
                     placeholder="Your Email"
                     required=""
                   />
                   <input
                     type="hidden"
                     name="action"
                     defaultValue="mailchimpsubscribe"
                   />
                   <button className="submit">
                     <i className="fa-regular fa-arrow-right-long" />
                   </button>
                 </div>
                 <div className="clearfix" />
                 <div id="subscribe-result">
                   <div className="subscription-success" />
                   <div className="subscription-error" />
                 </div>
               </form>
               <p className="mt-20">
                 Subscribe us and get all the benifits from today.
               </p>
             </div>
           </div>
         </div>
       </div>
       <div className="running-truck">
         <div className="truck" />
         <div className="truck-2" />
         <div className="truck-3" />
       </div>
     </div>
     <div className="copyright-area">
       <span id="currentYear"> </span> © Safe and Reliable Transportation ,
       All Rights Reserved.
     </div>
   </footer>
  {/*/.footer-section*/}
  <div id="scrollup">
    <button id="scroll-top" className="scroll-to-top">
      <i className="fa-regular fa-arrow-up" />
    </button>
  </div>
    </div>
  )
}

export default Contact